import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { countries } from "@mindlercare/schema";
import {
  fromUnixTime,
  getISOWeek,
  getYear,
  minutesToMilliseconds,
} from "date-fns";
import { getCountryCode } from "helpers/getCountryCode";
import { get } from "../../services/httpClient";

export const useOverviewData = ({
  psychologistId,
  startDateUnix,
  endDateUnix,
}: {
  psychologistId: number | null;
  startDateUnix: number;
  endDateUnix: number;
}) => {
  const countryCode = getCountryCode();
  const countryId = countries[countryCode].countryId;

  return useQuery({
    queryKey: ["overviewData", psychologistId, startDateUnix, endDateUnix],
    refetchOnMount: true,
    refetchInterval: minutesToMilliseconds(5),
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("fromDate", startDateUnix.toString());
      params.append("toDate", endDateUnix.toString());
      params.append("countryId", countryId.toString());

      if (psychologistId !== -1 && psychologistId !== null) {
        params.append("psychologistId", psychologistId.toString());
      }

      const res = await get<{ data: RawOverviewData }>(
        `statistics/slots?${params.toString()}`,
      );
      const rawOverviewData = res.data ?? null;
      const overviewData = rawOverviewData
        ? overviewDataModel(rawOverviewData)
        : null;

      return overviewData;
    },
  });
};

enum SlotStatusType {
  BOOKED = "BOOKED",
  CANCELED = "CANCELED",
  LATE_CANCELED = "LATE_CANCELED",
  NO_SHOW = "NO_SHOW",
  NO_SHOW_ALL = "NO_SHOW_ALL",
  OPEN = "OPEN",
  ORGANIZER_NO_SHOW = "ORGANIZER_NO_SHOW",
  TOTAL = "TOTAL",
  UNAVAILABLE = "UNAVAILABLE",
}

interface SlotStatus {
  count: number;
  percentage: number | null;
}

interface DayData extends Record<SlotStatusType, SlotStatus> {
  date: number;
  iso: string;
}

interface RawOverviewData extends Record<SlotStatusType, SlotStatus> {
  days: DayData[];
}

export function overviewDataModel(rawOverviewData: RawOverviewData) {
  let weeks = null;
  if (rawOverviewData?.days) {
    weeks = rawOverviewData.days.reduce(function (
      acc: Record<string, DayData[]>,
      day,
    ) {
      const date = fromUnixTime(day.date);
      const yearWeek = `${getYear(date)}-${getISOWeek(date)}`;
      // check if the week number exists
      if (typeof acc[yearWeek] === "undefined") {
        acc[yearWeek] = [];
      }

      acc[yearWeek].push(day);

      return acc;
    }, {});
  } else {
    return null;
  }
  return { ...rawOverviewData, weeks };
}
